import mapItemService from '@/services/mapItem.js';

export default {
	debug: false,
	namespaced: true,
	state: {
		mapItems: [],
		allMapItems: [],
		mapItem: {},
		searchParams: {
			mapId: '',
			orderBy: 'PositionNumber',
			pageSize: 10,
			currentPage: 1
		},
		totalCount: 0,
		totalPages: 0
	},

	mutations: {
		SET_MAP_ITEMS(state, mapItems) {
			state.mapItems = mapItems;
		},
		SET_ALL_MAP_ITEMS(state, mapItems) {
			state.allMapItems = mapItems;
		},
		SET_MAP_ITEM(state, mapItem) {
			state.mapItem = mapItem;
		},
		SET_PAGESIZE(state, pageSize) {
			state.searchParams.pageSize = pageSize;
		},
		SET_CURRENTPAGE(state, currentPage) {
			state.searchParams.currentPage = currentPage;
		},
		SET_TOTALPAGES(state, totalPages) {
			state.totalPages = totalPages;
		},
		SET_TOTALCOUNT(state, totalCount) {
			state.totalCount = totalCount;
		},
		SET_MAPID(state, mapId) {
			state.searchParams.mapId = mapId;
		}
	},

	actions: {
		async getMapItem({ commit }, mapItemId) {
			return await mapItemService
				.getMapItem(mapItemId)
				.then(data => {
					commit('SET_MAP_ITEM', data);
				})
				.catch(err => {
					console.log('Error getting map item: ', err);
				});
		},

		async getMapItems({ state, commit, dispatch }) {
			dispatch('appStore/setLoading', 1, { root: true });

			return await mapItemService
				.getMapItems(state.searchParams)
				.then(data => {
					const paginationValues = data._pagination;

					if (state.searchParams.currentPage <= paginationValues.totalPages || paginationValues.totalPages == 0) {
						commit('SET_MAP_ITEMS', data);
						commit('SET_CURRENTPAGE', paginationValues.currentPage);
						commit('SET_TOTALCOUNT', paginationValues.totalCount);
						commit('SET_TOTALPAGES', paginationValues.totalPages);
						dispatch('appStore/setLoading', -1, { root: true });
					} else {
						commit('SET_CURRENTPAGE', paginationValues.totalPages);
						dispatch('getMapItems');
						dispatch('appStore/setLoading', -1, { root: true });
					}
				})
				.catch(err => {
					console.log('Error getting map items: ', err);
				});
		},
		async getAllMapItems({ commit, dispatch }, mapId) {
			dispatch('appStore/setLoading', 1, { root: true });
			var searchParams = {
				mapId: mapId,
				orderBy: '',
				currentPage: 1,
				pageSize: 1000
			};

			return await mapItemService
				.getMapItems(searchParams)
				.then(data => {
					commit('SET_ALL_MAP_ITEMS', data);
					dispatch('appStore/setLoading', -1, { root: true });
				})
				.catch(err => {
					console.log('Error getting all mapItems: ', err);
					dispatch('appStore/setLoading', -1, { root: true });
				});
		},
		async createMapItem({ state, dispatch }, mapItem) {
			return await mapItemService
				.createMapItem(mapItem)
				.then(data => {
					if (mapItem.positionX === 50) {
						dispatch('getMapItems');
					} else {
						dispatch('getAllMapItems', state.searchParams.mapId);
					}

					return data;
				})
				.catch(err => {
					console.log('Error creating map item: ', err);
				});
		},
		async updateMapItem({ state, dispatch }, mapItem) {
			return await mapItemService
				.updateMapItem(mapItem)
				.then(() => {
					if (mapItem.positionX === 50) {
						dispatch('getMapItems');
					} else {
						dispatch('getAllMapItems', state.searchParams.mapId);
					}
				})
				.catch(err => {
					console.log('Error updating map item: ', err);
				});
		},
		async deleteMapItem({ state, dispatch }, mapItem) {
			return await mapItemService
				.deleteMapItem(mapItem.id)
				.then(() => {
					if (mapItem.positionX === 50) {
						dispatch('getMapItems');
					} else {
						dispatch('getAllMapItems', state.searchParams.mapId);
					}
				})
				.catch(err => {
					console.log('Error deleting map item: ', err);
				});
		},

		setMapItem({ commit }, mapItem) {
			commit('SET_MAP_ITEM', mapItem);
		},
		setMapItems({ commit }, mapItems) {
			commit('SET_MAP_ITEMS', mapItems);
		},
		setCurrentPage({ commit }, currentPage) {
			commit('SET_CURRENTPAGE', currentPage);
		},
		setPageSize({ commit }, pageSize) {
			commit('SET_PAGESIZE', pageSize);
		},
		setTotalPages({ commit }, totalPages) {
			commit('SET_TOTALPAGES', totalPages);
		},
		setTotalCount({ commit }, totalCount) {
			commit('SET_TOTALCOUNT', totalCount);
		},
		setMapItemMapId({ commit }, mapId) {
			commit('SET_MAPID', mapId);
		}
	},

	getters: {
		totalPages: state => {
			return state.totalPages;
		},
		totalCount: state => {
			return state.totalCount;
		},
		currentPage: state => {
			return state.searchParams.currentPage;
		},
		pageSize: state => {
			return state.searchParams.pageSize;
		},
		allMapItems: state => {
			return state.allMapItems;
		},
		mapItem: state => {
			return state.mapItem;
		},
		mapItems: state => {
			return state.mapItems;
		},
		dropdownMapItems: state => {
			return state.dropdownMapItems;
		},
		pagination: state => {
			return {
				currentPage: state.searchParams.currentPage,
				pageSize: state.searchParams.pageSize,
				totalPages: state.totalPages,
				totalCount: state.totalCount
			};
		}
	}
};
